/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Components_Dropbox_Ingest_Approval_ApprovedInputs */

const es_components_dropbox_ingest_approval_approved = /** @type {(inputs: Components_Dropbox_Ingest_Approval_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingesta de Dropbox aprobada`)
};

const en_components_dropbox_ingest_approval_approved = /** @type {(inputs: Components_Dropbox_Ingest_Approval_ApprovedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dropbox ingestion approved`)
};

/**
* | output |
* | --- |
* | "Dropbox ingestion approved" |
*
* @param {Components_Dropbox_Ingest_Approval_ApprovedInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const components_dropbox_ingest_approval_approved = /** @type {((inputs?: Components_Dropbox_Ingest_Approval_ApprovedInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Dropbox_Ingest_Approval_ApprovedInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_components_dropbox_ingest_approval_approved(inputs)
	return en_components_dropbox_ingest_approval_approved(inputs)
});
export { components_dropbox_ingest_approval_approved as "components.dropbox_ingest_approval.approved" }